import {FC} from "react";
import {useTranslation} from "react-i18next";
import {OemInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TabRow} from "../../../../../tab-content";
import {OemTableBody} from "../../../../overview";
import "./OemsRow.scss";

export interface OemsRowProps {
  oems: OemInput[];
}

export const OemsRow: FC<OemsRowProps> = ({oems}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"oems"}
      header={<h4>{t("entity-detail.dealer.oems.details")}</h4>}>
      <OemTableBody oems={oems} />
    </TabRow>
  );
};
